import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { decode } from 'blurhash';

var BlurhashCanvas = /*#__PURE__*/React.memo(function (_a) {
  var hash = _a.hash,
    _a$width = _a.width,
    width = _a$width === void 0 ? 128 : _a$width,
    _a$height = _a.height,
    height = _a$height === void 0 ? 128 : _a$height,
    punch = _a.punch,
    rest = __rest(_a, ["hash", "width", "height", "punch"]);
  var w = parseInt(width.toFixed(0), 10);
  var h = parseInt(height.toFixed(0), 10);
  var canvasRef = React.useRef(null);
  React.useLayoutEffect(function () {
    if (hash && canvasRef.current) {
      try {
        var image = decode(hash, w, h, punch);
        var ctx = canvasRef.current.getContext("2d");
        var imageData = ctx.createImageData(w, h);
        imageData.data.set(image);
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        ctx.putImageData(imageData, 0, 0);
      } catch (err) {
        console.log(">>>>> [SYS] error occurred", err);
      }
    }
  }, [hash, punch, w, h]);
  return jsx("canvas", Object.assign({}, rest, {
    height: w,
    width: h,
    ref: canvasRef
  }));
});

export { BlurhashCanvas };
